import { createSelector } from 'reselect';
import { StepTypes } from 'lib/constants/preRegister';
import { RootState } from 'store/types';
import { CheckListItem } from './types';

export const PreRegistrationDataSelector = (state: RootState) => state.preRegister.data;
export const PreRegistrationFetchingSelector = (state: RootState) => state.preRegister.isFetching;
export const PreRegistrationErrorSelector = (state: RootState) => state.preRegister.error;

export const PreRegistrationPatientInfoSelector = (state: RootState) =>
  state.preRegister.data?.patientInfo;
export const PreRegistrationPatientGuarantorInfo = (state: RootState) =>
  state.preRegister.data?.guarantorInfo;
export const PreRegistrationDemographicTypesSelector = (state: RootState) =>
  state.preRegister.data?.demographicTypes;
export const PreRegistrationVisitDetailSelector = (state: RootState) =>
  state.preRegister.data?.visitDetail;
export const PreRegistrationFacilitySelector = (state: RootState) =>
  state.preRegister.data?.visitDetail?.location;
export const PreRegistrationCheckListSelector = (state: RootState) =>
  state.preRegister.data?.checkList;
export const PreRegistrationJwtTokenSelector = (state: RootState) => state.preRegister.jwtToken;
export const PreRegistrationEncounterInfoSelector = (state: RootState) =>
  state.preRegister.data?.encounterInfo;
export const PreRegistrationEventIdSelector = (state: RootState) => state.preRegister.eventId;
export const PreRegistrationMmiSelector = (state: RootState) =>
  state.preRegister.data?.guarantorInfo?.id;
export const PreRegistrationSkipPaymentFlagsSelector = (state: RootState) =>
  state.preRegister.skipPaymentFlags;
export const PreRegistrationColletionAttempt = (state: RootState) =>
  state.preRegister.updateCollectionAttempt;
export const PreRegistrationShouldSkipActivityCompleteSelector = (state: RootState) =>
  state.preRegister.skipPaymentFlags.selfPayElect;
export const PreRegistrationShouldSkipPaymentSelector = (state: RootState) =>
  Object.values(state.preRegister.skipPaymentFlags).some(flagValue => flagValue);

export const PreRegistrationCheckListStepByIdSelector = (id: string) => (
  state: RootState
): CheckListItem | undefined =>
  (PreRegistrationCheckListSelector(state) || []).find(step => step.id === id);

export const PreRegistrationSecondaryInsuranceSelector = createSelector(
  PreRegistrationCheckListSelector,
  (checklist: CheckListItem[] | undefined): CheckListItem | undefined => {
    checklist = checklist || [];
    return checklist.find((item: CheckListItem) => item.name === 'SecondaryInsCard');
  }
);

export const PreRegistrationHasSkippedConsentFormSelector = createSelector(
  PreRegistrationCheckListSelector,
  (checklist: CheckListItem[] | undefined) => {
    if (!checklist) {
      return true;
    }
    return checklist
      .filter(
        (item: CheckListItem) =>
          item.type === StepTypes.CONSENT_FORM && item.name !== 'Self-PayAcknowledgementLetter'
      )
      .some((consentForm: CheckListItem) => !consentForm.docCacheId);
  }
);

export const PreRegistrationSelfPaySelector = (state: RootState) => state.preRegister.selfPay;
export const PreRegistrationGuarantorChangeSelector = (state: RootState) =>
  state.preRegister.skipPaymentFlags.guarantorInfoChanged;
export const PreRegistrationInsuranceChangeSelector = (state: RootState) =>
  state.preRegister.skipPaymentFlags.insuranceInfoChanged;
